import _ from "lodash";

const stringIsEmpty = function(str) {
  return _(str)
    .chain()
    .thru(_.toString)
    .thru(_.trim)
    .thru(_.split)
    .thru(_.first)
    .thru(_.isEmpty)
    .value();
};

export { stringIsEmpty };
